import { render, staticRenderFns } from "./editGroup.vue?vue&type=template&id=c721854e&scoped=true&"
import script from "./editGroup.vue?vue&type=script&lang=js&"
export * from "./editGroup.vue?vue&type=script&lang=js&"
import style0 from "./editGroup.vue?vue&type=style&index=0&id=c721854e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c721854e",
  null
  
)

export default component.exports